import axios from "../utils/axios";

export const fetchEmails = async (
  resultsPerPage,
  page,
  search,
  orderBy,
  orderDirection,
  port_authority_id
) => {
  const res = await axios
    .get("/emails/", {
      params: {
        resultsPerPage,
        page,
        search,
        orderBy,
        orderDirection,
        port_authority_id,
      },
    })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};
